import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import jwt_decode from "jwt-decode";
import setAuthToken from "./utils/setAuthToken";
import { setCurrentUser, logoutUser } from "./actions/authActions";
import { clearCurrentProfile } from "./actions/profileActions";

import { Provider } from "react-redux";
import store from "./store";

import PrivateRoute from "./components/common/PrivateRoute";

import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";
import Landing from "./components/layout/Landing";
import Register from "./components/auth/Register";
import Login from "./components/auth/Login";
import Dashboard from "./components/dashboard/Dashboard";
import CreateProfile from "./components/create-profile/CreateProfile";
import EditProfile from "./components/edit-profile/EditProfile";
import AddExperience from "./components/add-credentials/AddExperience";
import AddEducation from "./components/add-credentials/AddEducation";
import Profiles from "./components/profiles/Profiles";
import Profile from "./components/profile/Profile";
import Posts from "./components/posts/Posts";
import Post from "./components/post/Post";
import NotFound from "./components/not-found/NotFound";

import "./App.css";
import Admin from "./components/common/Admin";
import AdminRoute from "./components/common/AdminRoute";
import About from "./components/layout/About";
import Brussels from "./components/brussels/Brussels";
import BrusselItem from "./components/brussels/BrusselItem";
import HotFeeds from "./components/hot/HotFeeds";
import ExtraNowFeeds from "./components/extra/ExtraNowFeeds";

// Check for token
if (localStorage.jwtToken) {
  // Set auth token header auth
  setAuthToken(localStorage.jwtToken);
  // Decode token and get user info and exp
  const decoded = jwt_decode(localStorage.jwtToken);
  // Set user and isAuthenticated
  store.dispatch(setCurrentUser(decoded));

  // Check for expired token
  const currentTime = Date.now() / 1000;
  if (decoded.exp < currentTime) {
    // Logout user
    store.dispatch(logoutUser());
    // Clear current Profile
    store.dispatch(clearCurrentProfile());
    // Redirect to login
    window.location.href = "/login";
  }
}

class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <Router>
          <div className="App">
            <Navbar />
            <div className="row">
              <div className="col-lg-2 text-left d-none d-md-block">
                <iframe
                  id="$iradid"
                  title="FR_Honest_120x600"
                  src="//a.impactradius-go.com/gen-ad-code/2913702/1116886/12133/"
                  width="120"
                  height="600"
                  scrolling="no"
                  frameBorder="0"
                ></iframe>
              </div>
              <div className="col-lg-8">
                <Route exact path="/" component={Landing} />
                <div className="container">
                  <Route exact path="/register" component={Register} />
                  <Route exact path="/login" component={Login} />
                  <Route exact path="/profiles" component={Profiles} />
                  <Route exact path="/hotfeeds" component={HotFeeds} />
                  <Route exact path="/extrafeeds" component={ExtraNowFeeds} />
                  <Route exact path="/about" component={About} />
                  <Route
                    exact
                    path="/profiles/search/:keyword/"
                    component={Profiles}
                  />
                  <Route
                    exact
                    path="/profiles/search/:status/"
                    component={Profiles}
                  />
                  <Route exact path="/profile/:handle" component={Profile} />
                  <AdminRoute exact path="/admin" component={Admin} />

                  <Switch>
                    <PrivateRoute
                      exact
                      path="/dashboard"
                      component={Dashboard}
                    />
                  </Switch>
                  <Switch>
                    <PrivateRoute
                      exact
                      path="/create-profile"
                      component={CreateProfile}
                    />
                  </Switch>
                  <Switch>
                    <PrivateRoute
                      exact
                      path="/edit-profile"
                      component={EditProfile}
                    />
                  </Switch>
                  <Switch>
                    <PrivateRoute
                      exact
                      path="/add-experience"
                      component={AddExperience}
                    />
                  </Switch>
                  <Switch>
                    <PrivateRoute
                      exact
                      path="/add-education"
                      component={AddEducation}
                    />
                  </Switch>
                  <Switch>
                    <PrivateRoute exact path="/brussels" component={Brussels} />
                  </Switch>

                  <Switch>
                    <PrivateRoute
                      exact
                      path="/brussel/:id"
                      component={BrusselItem}
                    />
                  </Switch>

                  <Switch>
                    <PrivateRoute exact path="/feed" component={Posts} />
                    {/* <PrivateRoute path="/feed/search/:keyword" component={Posts} /> */}
                  </Switch>

                  <Switch>
                    <PrivateRoute exact path="/post/:id" component={Post} />
                  </Switch>
                  <Route exact path="/not-found" component={NotFound} />
                </div>
              </div>
              <div
                className="col-lg-2 text-left bg-info col-sm-2 d-none d-md-block "
                style={{
                  position: "absolute",
                  right: 0,
                  marginTop: "25px",
                  marginRight: "5px",
                }}
              >
                <h3 id="spota_home" style={{ marginTop: "20px" }}>
                  <a href="https://spotahome.sjv.io/c/2913702/979662/12133">
                    <span className="bg-info text-white ">Spotahome</span>
                  </a>
                </h3>
                <h3 id="rooms_brussels" style={{ marginTop: "2px" }}>
                  <a href="https://spotahome.sjv.io/c/2913702/952435/12133">
                    <span className="bg-info text-white ">Brussels</span>
                  </a>
                </h3>
                <h3 id="rooms_paris " style={{ marginTop: "2px" }}>
                  <a href="https://spotahome.sjv.io/c/2913702/952433/12133">
                    <span className="bg-info text-white ">Paris</span>
                  </a>
                </h3>
                <h3 id="rooms_london" style={{ marginTop: "2px" }}>
                  <a href="https://spotahome.sjv.io/c/2913702/952439/12133">
                    <span className="bg-info text-white ">London</span>
                  </a>
                </h3>
                <h3 id="_rooms_dublin" style={{ marginTop: "2px" }}>
                  <a href="https://spotahome.sjv.io/c/2913702/952441/12133">
                    <span className="bg-info text-white ">Dublin</span>
                  </a>
                </h3>
                <h3 id="rooms_berlin" style={{ marginTop: "2px" }}>
                  <a href="https://spotahome.sjv.io/c/2913702/952437/12133">
                    <span className="bg-info text-white ">Berlin</span>
                  </a>
                </h3>
                <h3 id="rooms_madrid">
                  <a href="https://spotahome.sjv.io/c/2913702/938286/12133">
                    <span className="bg-info text-white ">Madrid</span>
                  </a>
                </h3>
                <h3 id="rooms_barcelona" style={{ marginTop: "2px" }}>
                  <a href="https://spotahome.sjv.io/c/2913702/952417/12133">
                    <span className="bg-info text-white ">Barcelona</span>
                  </a>
                </h3>
                <h3 id="rooms_vienna" style={{ marginTop: "2px" }}>
                  <a href="https://spotahome.sjv.io/c/2913702/952443/12133">
                    <span className="bg-info text-white ">Vienna</span>
                  </a>
                </h3>
              </div>
            </div>

            <Footer />
          </div>
        </Router>
      </Provider>
    );
  }
}

export default App;
